"use strict";

// https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion
const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const ARIA_EXPANDED = "aria-expanded";

const typography = require("!!css-loader!../../tokens/typography.css").default;

class Element extends HTMLElement {
    constructor(template) {
        super();

        this.root = this.attachShadow({ mode: "open" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(typography);
        this.root.adoptedStyleSheets = [sheet];

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.accortionTitle = this.root.querySelector('.accordion-title');
        const now = Date.now();
        const sectionId = "section-" + now;
        this.accortionTitle.setAttribute("aria-controls", sectionId);
        this.accordion = this.root.querySelector('.swiftref-accordion')
        this.accordionContent = this.root.querySelector('.accordion-content');
        this.accordionContent.id = sectionId;
        this.accordionContent.setAttribute("aria-labelledby", "accordion-" + now);
        this.accortionTitle.addEventListener("click", function () {
            this.expanded = !this.expanded;
        }.bind(this));
        this.initSlots();


    }

    get expanded() {
        return this.hasAttribute("expanded");
    }
    set expanded(value) {
        this.setAttribute("expanded", "");
    }


    static get observedAttributes() {
        return ["expanded"];
    }

    toggle () {

        const isOpen = this.accordion.hasAttribute("open");
        if (isOpen === false) {
            // this.accordionContent.classList.add("hidden");
            this.accordionContent.removeAttribute("hidden")
            this.accortionTitle.setAttribute(ARIA_EXPANDED, "true");
        } else {
            // this.accordionContent.classList.remove("hidden");
            this.accordionContent.setAttribute("hidden", "")
            this.accortionTitle.setAttribute(ARIA_EXPANDED, "false");
        }
    }



    initSlots () {

        if (this.innerHTML) {
            const slot = this.querySelector('[slot="title"]');
            this.accortionTitle.textContent = slot.innerText;
            this.removeChild(slot);
        }
        for (const child of this.childNodes) {
            this.accordionContent.appendChild(child);
        }

    }


    renderAttribute (name, value) {
        switch (name) {
            case "expanded":
                this.toggle();
                break;
            default:
                break;
        }
    }


    connectedCallback() {
        if (this.expanded) {
            this.accordion.setAttribute("open", "");
        }
    }



    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-accordion", Element);

module.exports = Element;
